import { default as TSAACounties } from './TSA-A/data/counties'
import { default as TSABCounties } from './TSA-B/data/counties'
import { default as TSACCounties } from './TSA-C/data/counties'
import { default as TSADCounties } from './TSA-D/data/counties'
import { default as TSAECounties } from './TSA-E/data/counties'
import { default as TSAFCounties } from './TSA-F/data/counties'
import { default as TSAGCounties } from './TSA-G/data/counties'
import { default as TSAHCounties } from './TSA-H/data/counties'
import { default as TSAICounties } from './TSA-I/data/counties'
import { default as TSAJCounties } from './TSA-J/data/counties'
import { default as TSAKCounties } from './TSA-K/data/counties'
import { default as TSALCounties } from './TSA-L/data/counties'
import { default as TSAMCounties } from './TSA-M/data/counties'
import { default as TSANCounties } from './TSA-N/data/counties'
import { default as TSAOCounties } from './TSA-O/data/counties'
import { default as TSAPCounties } from './TSA-P/data/counties'
import { default as TSAQCounties } from './TSA-Q/data/counties'
import { default as TSARCounties } from './TSA-R/data/counties'
import { default as TSASCounties } from './TSA-S/data/counties'
import { default as TSATCounties } from './TSA-T/data/counties'
import { default as TSAUCounties } from './TSA-U/data/counties'
import { default as TSAVCounties } from './TSA-V/data/counties'
import { hexToRgb } from '../index'
import {
  blue,
  cyan,
  geekblue,
  gold,
  green,
  magenta,
  orange,
  purple,
  red,
  volcano,
  yellow
} from '@ant-design/colors'

export interface RAC {
  key: string
  name: string
  counties: any
  center: google.maps.LatLng
  zoom: number
  color: [number, number, number]
}

const RACs: { [key: string]: RAC } = {
  'TSA-A': {
    key: 'A',
    name: 'Panhandle',
    counties: TSAACounties,
    center: new google.maps.LatLng(35.56142838166134, -101.581122664868),
    zoom: 8,
    color: hexToRgb(green[6])
  },
  'TSA-B': {
    key: 'B',
    name: 'BRAC',
    counties: TSABCounties,
    center: new google.maps.LatLng(33.49575113065202, -101.6305611414295),
    zoom: 8,
    color: hexToRgb(purple[5])
  },
  'TSA-C': {
    key: 'C',
    name: 'North Texas',
    counties: TSACCounties,
    center: new google.maps.LatLng(33.742765724089104, -98.8180611414295),
    zoom: 8,
    color: hexToRgb(yellow[5])
  },
  'TSA-D': {
    key: 'D',
    name: 'Big Country',
    counties: TSADCounties,
    center: new google.maps.LatLng(32.66727957057103, -99.691474227367),
    zoom: 8,
    color: hexToRgb(magenta[5])
  },
  'TSA-E': {
    key: 'E',
    name: 'North Central Texas Trauma',
    counties: TSAECounties,
    center: new google.maps.LatLng(32.971958083692115, -97.164618758617),
    zoom: 8,
    color: hexToRgb(red[4])
  },
  'TSA-F': {
    key: 'F',
    name: 'Northeast Texas',
    counties: TSAFCounties,
    center: new google.maps.LatLng(33.427010425744406, -95.0058052820545),
    zoom: 8,
    color: hexToRgb(cyan[5])
  },
  'TSA-G': {
    key: 'G',
    name: 'Piney Woods',
    counties: TSAGCounties,
    center: new google.maps.LatLng(32.23154525071894, -95.143134383617),
    zoom: 8,
    color: hexToRgb(gold[4])
  },
  'TSA-H': {
    key: 'H',
    name: 'Deep East Texas',
    counties: TSAHCounties,
    center: new google.maps.LatLng(31.142462330271357, -94.5224068445545),
    zoom: 8,
    color: hexToRgb(blue[4])
  },
  'TSA-I': {
    key: 'I',
    name: 'Border',
    counties: TSAICounties,
    center: new google.maps.LatLng(31.489855595821055, -105.2829826608607),
    zoom: 8,
    color: hexToRgb(blue[7])
  },
  'TSA-J': {
    key: 'J',
    name: 'Texas "J"',
    counties: TSAJCounties,
    center: new google.maps.LatLng(30.916643372313207, -103.0637443796107),
    zoom: 8,
    color: hexToRgb(orange[5])
  },
  'TSA-K': {
    key: 'K',
    name: 'Concho Valley',
    counties: TSAKCounties,
    center: new google.maps.LatLng(31.133180332647193, -100.5588615671107),
    zoom: 8,
    color: hexToRgb(volcano[6])
  },
  'TSA-L': {
    key: 'L',
    name: 'Central Texas',
    counties: TSALCounties,
    center: new google.maps.LatLng(31.23432604161048, -97.8012932077357),
    zoom: 8,
    color: hexToRgb(orange[3])
  },
  'TSA-M': {
    key: 'M',
    name: 'Heart of Texas',
    counties: TSAMCounties,
    center: new google.maps.LatLng(31.653765531841024, -97.1421135202357),
    zoom: 8,
    color: hexToRgb(green[8])
  },
  'TSA-N': {
    key: 'N',
    name: 'Brazos Valley',
    counties: TSANCounties,
    center: new google.maps.LatLng(30.718614469220324, -96.2577141061732),
    zoom: 8,
    color: hexToRgb(yellow[3])
  },
  'TSA-O': {
    key: 'O',
    name: 'Capital Area Trauma',
    counties: TSAOCounties,
    center: new google.maps.LatLng(30.44865944961199, -97.97800999740477),
    zoom: 8,
    color: hexToRgb(geekblue[4])
  },
  'TSA-P': {
    key: 'P',
    name: 'Southwest Texas',
    counties: TSAPCounties,
    center: new google.maps.LatLng(29.439583191824116, -99.37703131697201),
    zoom: 8,
    color: hexToRgb(cyan[3])
  },
  'TSA-Q': {
    key: 'Q',
    name: 'Southeast Texas',
    counties: TSAQCounties,
    center: new google.maps.LatLng(29.75428206402858, -95.85821099591112),
    zoom: 8,
    color: hexToRgb(green[2])
  },
  'TSA-R': {
    key: 'R',
    name: 'East Texas Gulf Coast',
    counties: TSARCounties,
    center: new google.maps.LatLng(30.059029495443696, -94.49264363471117),
    zoom: 8,
    color: hexToRgb(geekblue[3])
  },
  'TSA-S': {
    key: 'S',
    name: 'Golden Crescent',
    counties: TSASCounties,
    center: new google.maps.LatLng(28.95952640944086, -97.07443074408617),
    zoom: 8,
    color: hexToRgb(magenta[3])
  },
  'TSA-T': {
    key: 'T',
    name: 'Seven Flags',
    counties: TSATCounties,
    center: new google.maps.LatLng(27.52231692631817, -99.21836682883477),
    zoom: 8,
    color: hexToRgb(yellow[6])
  },
  'TSA-U': {
    key: 'U',
    name: 'Coastal Bend',
    counties: TSAUCounties,
    center: new google.maps.LatLng(27.792060236469613, -97.93604337655293),
    zoom: 8,
    color: hexToRgb(green[2])
  },
  'TSA-V': {
    key: 'V',
    name: 'Lower Rio Grande Valley',
    counties: TSAVCounties,
    center: new google.maps.LatLng(26.42297804701919, -98.13379728280293),
    zoom: 8,
    color: hexToRgb(gold[3])
  }
}

export default RACs
